import { keyframes } from 'styled-components'

export const SlideIn = keyframes`
  100% {
    transform: translate3d(-40rem, 0, 0);
  }
`
